import { render } from "./HunanBack.vue?vue&type=template&id=8c0b9f7c&scoped=true"
import script from "./HunanBack.vue?vue&type=script&lang=js"
export * from "./HunanBack.vue?vue&type=script&lang=js"

import "./HunanBack.vue?vue&type=style&index=0&id=8c0b9f7c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0b9f7c"]])

export default __exports__